import { TipoOpposizione } from 'src/app/common/models/tipologiche/tipo-opposizione';
import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { TipoRicorso } from "../../../../common/models/tipologiche/tipo-ricorso.";

export class FascicoloRicorsoLavoro extends FascicoloFull {
  tipoRicorso: TipoRicorso;
  tipoOpposizione: TipoOpposizione;
  sezione: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
